import React from 'react';
import { PageOptionType } from '@app/component/tabs/PageTabs';
import PageButtonTabs from '@app/component/tabs/PageButtonTabs';


const RateshopperSettingsPage = React.memo(() => {

	const tabs: PageOptionType[] = [
		{
			label: 'General Settings',
			link: '/secured/rateshopper/rates/settings',
		}, {
			label: 'Calendar',
			link: '/secured/rateshopper/rates/settings/calendar',
		}, {
			label: 'Price',
			link: '/secured/rateshopper/rates/settings/price',
		}, {
			label: 'Availability',
			link: '/secured/rateshopper/rates/settings/availability',
		}, {
			label: 'Room-Mapping',
			link: '/secured/rateshopper/rates/settings/room-mapping',
		}, {
			label: 'Competitors',
			link: '/secured/rateshopper/rates/settings/competitors',
		}, {
			label: 'Competitor Groups',
			link: '/secured/rateshopper/rates/settings/competitor-groups',
		},
	];

	return <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
		<div className="mt-8">
			<PageButtonTabs options={tabs} isOutlet />
		</div>
	</div>;

});


export default RateshopperSettingsPage;